(() => {
  function init(root = document) {
    root.querySelectorAll('[data-d105-offers]').forEach(panel => {
      if (panel.dataset.ready) return;
      const form = panel.closest('form');
      if (!form) return;
      panel.dataset.ready = 'true';
      const data = JSON.parse(panel.querySelector('[data-d105-data]').textContent);
      const qty = form.querySelector('[name="quantity"]');
      const bundle = form.querySelector('[data-d105-bundle]');
      const add = bundle?.querySelector('[data-d105-add]');
      const error = bundle?.querySelector('[data-d105-error]');
      const active = panel.dataset.active === 'true';
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:panel.dataset.currency || 'USD'});
      const money = cents => formatter.format(cents / 100);
      const rate = count => active ? (count >= 3 ? .10 : count >= 2 ? .05 : 0) : 0;
      const variant = () => data.variants.find(v => String(v.id) === String(new FormData(form).get('id')));
      const selected = () => Array.from(bundle?.querySelectorAll('.d105-companion') || []).filter(row => row.querySelector('[data-d105-pick]').checked).map(row => row.querySelector('[data-d105-variant]').selectedOptions[0]);
      const text = (amount, count, heading) => {
        const saving = Math.floor(amount * rate(count));
        return heading + ' ' + money(amount - saving) + (saving ? ' · ' + data.copy.save + ' ' + money(saving) : '');
      };
      let busy = false;
      function update() {
        const v = variant();
        const count = Math.max(1, parseInt(qty?.value || '1', 10));
        const max = v?.managed && v.policy !== 'continue' ? Math.max(0,v.inventory) : 50;
        panel.querySelectorAll('[data-d105-qty]').forEach(button => {
          const n = Number(button.dataset.d105Qty);
          button.disabled = !v?.available || n > max || busy || (qty?.tagName === 'SELECT' && !Array.from(qty.options).some(option => Number(option.value) === n));
          button.setAttribute('aria-pressed',String(count === n));
          button.querySelector('small').textContent = v ? money(v.price * n - Math.floor(v.price * n * rate(n))) : '';
        });
        panel.querySelector('[data-d105-estimate]').textContent = v?.available ? text(v.price * count, count, data.copy.estimate) : '';
        const extras = selected();
        if (add) add.disabled = busy || !v?.available || !extras.length || count > max;
        if (bundle) bundle.querySelector('[data-d105-bundle-total]').textContent = v?.available && extras.length ? text(v.price * count + extras.reduce((s,o)=>s+Number(o.dataset.price),0), count + extras.length, data.copy.bundle) : '';
      }
      panel.querySelectorAll('[data-d105-qty]').forEach(button => button.addEventListener('click', () => {
        if (!qty) return;
        qty.value = button.dataset.d105Qty;
        qty.dispatchEvent(new Event('change',{bubbles:true}));
        update();
      }));
      form.addEventListener('change', () => requestAnimationFrame(() => requestAnimationFrame(update)));
      form.addEventListener('input', update);
      const selector = form.querySelector('[name="id"]');
      if (selector) new MutationObserver(update).observe(selector,{attributes:true,childList:true,subtree:true});
      if (qty) new MutationObserver(update).observe(qty,{childList:true});
      add?.addEventListener('click', async () => {
        if (busy || add.disabled || !form.reportValidity()) return;
        const formData = new FormData(form);
        const main = {id:Number(formData.get('id')),quantity:Number(formData.get('quantity') || 1)};
        const properties = {};
        for (const [key,value] of formData) if (key.startsWith('properties[') && key.endsWith(']') && typeof value === 'string') properties[key.slice(11,-1)] = value;
        if (Object.keys(properties).length) main.properties = properties;
        if (formData.get('selling_plan')) main.selling_plan = formData.get('selling_plan');
        const items = [main,...selected().map(o=>({id:Number(o.value),quantity:1}))];
        const original = add.textContent;
        busy = true; update(); add.textContent = data.copy.busy; error.hidden = true;
        try {
          const response = await fetch(panel.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || data.copy.error);
          window.location.assign(panel.dataset.cartUrl);
        } catch (problem) {
          error.textContent = (problem.message || data.copy.error) + ' ' + data.copy.error;
          error.hidden = false;
          busy = false; add.textContent = original; update();
        }
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>init()); else init();
  document.addEventListener('shopify:section:load', event=>init(event.target));
})();
